<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="3" lg="4" md="12" v-for="sub in mySubreddits" :key="sub.display_name">
        <v-card
            class="mx-auto"
            max-width="400"
        >
          <v-img
              class="white--text align-end"
              height="200px"
              :src="sub.banner_image"
          >
            <v-card-title style="background-color: rgba(0,0,0,0.5);">
              <v-avatar size="36">
                <img
                    :src="sub.image"
                    alt="John"
                >
              </v-avatar>
               <span class="ml-3">r/{{sub.name}}</span>
            </v-card-title>
          </v-img>

          <v-card-subtitle class="pb-0" v-if="!isConfigEmpty(sub.sleuthConfig)">
            Added on {{sub.sleuthConfig.added_at | format_date}}
          </v-card-subtitle>
          <v-card-subtitle class="pb-0" v-else>
            Not currently registered
          </v-card-subtitle>

          <v-card-text class="text--primary">
            <div>{{ sub.subscribers }} Subscribers</div>


          </v-card-text>

          <v-card-actions v-if="!isConfigEmpty(sub.sleuthConfig)">
            <v-btn
                color="orange"
                text
                :to="{path: `/my-subreddits/${sub.name}/info`}"
            >
              Edit
            </v-btn>

            <v-btn
                color="red"
                text
                v-if="sub.sleuthConfig.active"
                :loading="saving"
                @click="disableOnClick(sub.name)"
            >
              Disable
            </v-btn>
            <v-btn
                color="green"
                text
                v-else
                :loading="saving"
                @click="enableOnClick(sub.name)"
            >
              Enable
            </v-btn>
          </v-card-actions>
          <v-card-actions v-else>
            <v-btn
                color="green"
                text
                :to="`/my-subreddits/${sub.name}/activate`"
            >
              Activate
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
import {filterMixins} from "@/util/mixins/filterMixin";

const MonitoredSubRepo = RepositoryFactory.get('monitored')
const HistoryRepo = RepositoryFactory.get('history')
export default {
  name: "MySubsNew",
  mixins: [filterMixins],
  data: () => ({
    mySubreddits: [],
    isLoading: true,
    showAddSubDialog: false,
    saving: false
  }),
  methods: {
    loadSubreddits(after = '') {
      let url = `https://oauth.reddit.com/subreddits/mine/moderator?after=${after}`;
      return this.$redditApi.get(url)
          .then(res => {
            console.log(res)
            if (res.data.data.children.length === 0) {
              return;
            }
            res.data.data.children.forEach(sub => {
              const redditData = {
                name: sub.data.display_name,
                image: sub.data.icon_img ? sub.data.icon_img : require('../assets/images/reddit_logo.png'),
                subscribers: sub.data.subscribers,
                banner_image: null,
                sleuthConfig: null,
                repostCount: null
              }
              redditData.banner_image = sub.data.banner_background_image ? sub.data.banner_background_image.split('?')[0] : require('../assets/images/reddit-banner.png')
              MonitoredSubRepo.getMonitoredSubConfig({params: {token: this.$store.getters.token}}, redditData.name)
                .then(res => {
                  if (res.status === 'success') {
                    redditData.sleuthConfig = res.data
                  }
                })
              HistoryRepo.getRepostCount({subreddit: redditData.name})
                .then(res => {
                  redditData.repostCount = res.data;
                })
              this.mySubreddits.push(redditData)

            })
            if (res.data.data.after) {
              return this.loadSubreddits(res.data.data.after);
            }

          })
          .catch(function (error) {
            console.log(error);
          })
    },
    isConfigEmpty(config) {
      return !config || Object.keys(config).length === 0;
    },
    disableOnClick(subreddit) {
      this.saving = true;
      MonitoredSubRepo.updateMonitoredSub({name: subreddit, active: false}, {params: {token: this.$store.getters.token}})
          .then(res => {
            this.saving = false;
            if (res.status === 'error') {
              this.$emit('on-alert', {color: 'error', message: res.data})
            } else {
              let index = this.mySubreddits.findIndex(sub => sub.name === subreddit);
              this.mySubreddits[index].sleuthConfig.active = false;
              this.$emit('on-alert', {color: 'success', message: `Repost Sleuth Disabled On ${subreddit}`})
            }
          })
    },
    enableOnClick(subreddit) {
      MonitoredSubRepo.updateMonitoredSub({name: subreddit, active: true}, {params: {token: this.$store.getters.token}})
          .then(res => {
            this.saving = false;
            if (res.status === 'error') {
              this.$emit('on-alert', {color: 'error', message: res.data})
            } else {
              let index = this.mySubreddits.findIndex(sub => sub.name === subreddit);
              this.mySubreddits[index].sleuthConfig.active = true;
              this.$emit('on-alert', {color: 'success', message: `Repost Sleuth Enabled On ${subreddit}`})
            }
          })
    }

  },
  mounted() {
    this.loadSubreddits();
  },

}
</script>

<style scoped>

</style>
